<div class="map">
  <div class="content-container">
    <div class="row">
      <div class="col-xl-8 map-container">
        <div id="us_mapdata" class="overflow-hidden"></div>
        <ng-container *ngIf="data$ | async as data; else noMapData">
          <simplemap [mapData]="data" (onLocationClick)="location$.next($event)" (onReadyToLoad)="onReadyToLoad($event)" (onStateClick)="location$.next($event)" (onBackClick)="location$.next(undefined)">
          </simplemap>
        </ng-container>
        <ng-template #noMapData>
          <div class="alert alert-info">
            <strong> No data available to load the map. </strong>
          </div>
        </ng-template>
      </div>

      <div class="col-xl-4">
        <h1>Cost of Care</h1>

        <div class="hr"></div>

        <h3>
          <strong> What can you expect to pay for long-term care services? Costs vary widely based on where you live. </strong>
        </h3>

        <ul class="red-pluses">
          <li>Select a state to see average Long-Term Care costs for that state.</li>
          <li>Select a city to see nursing home, assisted living, and home health care costs specific to that city.</li>
        </ul>

        <div *ngTemplateOutlet="dataTemplate"></div>
      </div>
    </div>
  </div>
</div>

<ng-template #dataTemplate>
  <ng-container *ngIf="location$ | async as location">
    <div class="hr"></div>

    <h2>
      <span *ngIf="location.COC_CityName"> {{ location.COC_CityName }}, {{ location.COC_StateCode }} </span>
      <span *ngIf="!location.COC_CityName">
        {{ location.COC_StateName }}
      </span>
    </h2>

    <table class="table">
      <colgroup>
        <col style="width: 60%" />
        <col style="width: 13%" />
        <col style="width: 13%" />
        <col style="width: 13%" />
      </colgroup>
      <thead>
        <tr>
          <th style="width: 50%; border-bottom: none"></th>
          <th class="text-center" colspan="3" style="border-bottom: none">COST RANGE</th>
        </tr>
        <tr>
          <th style="border-bottom: none"></th>
          <th class="border-bottom">
            <span class="d-none d-md-block"> Minimum </span>
            <span class="d-md-none"> Min </span>
          </th>
          <th class="border-bottom">
            <strong>
              <span class="d-none d-md-block"> Average </span>
              <span class="d-md-none"> Avg </span>
            </strong>
          </th>
          <th class="border-bottom">
            <span class="d-none d-md-block"> Maximum </span>
            <span class="d-md-none"> Max </span>
          </th>
        </tr>
      </thead>
      <tbody>
        <tr class="no-hover">
          <td colspan="4">
            <span class="grey">HOME</span>
            <small class="grey-color">(hourly)</small>
          </td>
        </tr>
        <tr>
          <td>
            <strong> Homemaker </strong>
          </td>

          <td>{{ location.COC_HMS_Min }}</td>
          <td>
            <strong>{{ location.COC_HMS_Avg }}</strong>
          </td>
          <td>{{ location.COC_HMS_Max }}</td>
        </tr>
        <tr>
          <td>
            <strong> Home Health Aide </strong>
          </td>

          <td>{{ location.COC_HHA_Min }}</td>
          <td>
            <strong>{{ location.COC_HHA_Avg }}</strong>
          </td>
          <td>{{ location.COC_HHA_Max }}</td>
        </tr>
        <tr class="no-hover">
          <td colspan="4"></td>
        </tr>
      </tbody>
      <tbody>
        <tr class="no-hover">
          <td colspan="4">
            <span class="grey">FACILITY</span>
            <small class="grey-color">(daily)</small>
          </td>
        </tr>
        <tr>
          <td><strong> Assisted Living </strong>*</td>

          <td>{{ location.COC_ALF_Min }}</td>
          <td>
            <strong>{{ location.COC_ALF_Avg }}</strong>
          </td>
          <td>{{ location.COC_ALF_Max }}</td>
        </tr>
        <tr>
          <td><strong> Memory Care </strong>**</td>

          <td>{{ location.COC_MCF_Min }}</td>
          <td>
            <strong>{{ location.COC_MCF_Avg }}</strong>
          </td>
          <td>{{ location.COC_MCF_Max }}</td>
        </tr>
        <tr>
          <td><strong> Nursing Home </strong>***</td>

          <td>{{ location.COC_NH_Min }}</td>
          <td>
            <strong>{{ location.COC_NH_Avg }}</strong>
          </td>
          <td>{{ location.COC_NH_Max }}</td>
        </tr>
      </tbody>
    </table>

    <ul class="astericks">
      <li>* Single Person Occupancy</li>
      <li>** AL License - Single Person Occupancy</li>
      <li>*** Private Room</li>
    </ul>

    <p class="note">
      <strong>Note:</strong>
      {{ location.COC_CostDisclaimer }}
    </p>
  </ng-container>
</ng-template>
